import React, { createContext, useContext } from 'react';
var OnCloseLanguageContext = createContext(function () {
  return undefined;
});
var OnCloseMenuContext = createContext(function () {
  return undefined;
});

var OnCloseLanguageProvider = function OnCloseLanguageProvider(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  return React.createElement(OnCloseLanguageContext.Provider, {
    value: onClose
  }, children);
};

var OnCloseMenuProvider = function OnCloseMenuProvider(_ref2) {
  var children = _ref2.children,
      onClose = _ref2.onClose;
  return React.createElement(OnCloseMenuContext.Provider, {
    value: onClose
  }, children);
};

var useLanguageOnClose = function useLanguageOnClose() {
  return useContext(OnCloseLanguageContext);
};

var useMenuOnClose = function useMenuOnClose() {
  return useContext(OnCloseMenuContext);
};

export { OnCloseLanguageProvider, OnCloseMenuProvider, useLanguageOnClose, useMenuOnClose };